module.exports = __webpack_public_path__ + "static/media/19b.784c22a6.jpg";